export function getGameId(state) {
	return state.game.id;
}
// For Main Menu: Controls whether to show continue option or not
export function hasLoadedGame(state) {
	return Boolean(state.game.id);
}

export function hasGameCompleted(state){
	return state.game.gameCompleted;
}

export function getCash(state) {
	return state.game.cash;
}

export function hasStartedTurnWithAutoBookkeeper(state) {
	return state.game.hasStartedTurnWithAutoBookkeeper;
}
